/* eslint-disable react-hooks/exhaustive-deps */
import { Row, Col, message, Button, Modal, Card, Space } from 'antd';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import API from '../services/API';
import JsonFormatter from 'react-json-formatter';
import ReactJson from 'react18-json-view';
import LoaderComponent from '../components/Loader';

const VIEWS = {
  PREVIEW: 'PREVIEW',
  RAW: 'RAW',
};
function UserJsonPage({ rawJson }) {
  const [summaryData, setSummaryData] = useState(initialDataState);
  const [loading, setLoading] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [view, setView] = useState(VIEWS.PREVIEW);
  let { userId } = useParams();
  let history = useHistory();

  const getSummaryData = async () => {
    setLoading(true);
    try {
      let res = await API.getUserStats(userId);
      setSummaryData(res);
    } catch (error) {
      message.error('Unable to fetch User Details');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (rawJson) {
      setSummaryData(rawJson);
    }
  }, [rawJson])

  useEffect(() => {
    getSummaryData();
  }, []);


  const deleteAccountConfirmed = async () => {
    try {
      await API.deleteUserAccount(userId);
      setDeleteModalVisible(false);
      history.goBack();
      //goback handler
    } catch (error) {
      message.error('Unable to delete Account');
    } finally {
      setDeleteModalVisible(false);
    }
  };

  const closeDeleteModal = () => {
    setDeleteModalVisible(false);
  };

  const setDataView = (_view) => {
    setView(_view);
  };

  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col xs="24" xl={24}>
          {/* <JsonFormatter json={JSON.stringify(summaryData)} tabWith={4} jsonStyle={jsonStyle} /> */}
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            style={{ padding: 30 }}
          >

            <Space>
              <Button
                type="secondary"
                className={view === VIEWS.PREVIEW ? 'btn-selected' : ''}
                onClick={() => {
                  setDataView(VIEWS.PREVIEW);
                }}
              >
                Preview
              </Button>
              <Button
                type="secondary"
                className={view === VIEWS.RAW ? 'btn-selected' : ''}
                onClick={() => {
                  setDataView(VIEWS.RAW);
                }}
              >
                Raw JSON
              </Button>
            </Space>

            {loading ? <LoaderComponent /> :
              <div style={{ paddingTop: 30 }}>
                {view === VIEWS.PREVIEW ? (
                  <ReactJson src={summaryData} />
                ) : (
                  <JsonFormatter
                    json={JSON.stringify(summaryData)}
                    tabWith={4}
                    jsonStyle={jsonStyle}
                  />
                )}
              </div>}


          </Card>
        </Col>

        <Col
          xs={24}
          xl={24}
          sm={24}
          md={24}
          style={{
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            marginTop: 20,
          }}
        >
        </Col>
        <Modal
          title={'Confirmation'}
          centered
          mask={true}
          maskClosable={true}
          destroyOnClose={true}
          closable={true}
          visible={deleteModalVisible}
          onOk={deleteAccountConfirmed}
          onCancel={closeDeleteModal}
          className="confirm-modal"
        >
          <p>Are you sure you want to Delete this account?</p>
        </Modal>
      </Row>
    </div>
  );
}

export default UserJsonPage;

const initialDataState = {
  userSummary: {},
  accountDetails: {},
  saveAndBuildCredit: {},
  plaidAccount: {},
};

const jsonStyle = {
  propertyStyle: { color: 'red' },
  stringStyle: { color: 'green' },
  numberStyle: { color: 'darkorange' },
};
